import React, { Component } from "react";

import Claimed from "./icons/Claimed";
import Clear from "./Clear";
import Downshift from "downshift";
import CategoryOption from "./options/CategoryOption";
import Menu from "./elements/Menu";
import OptionsWrapper from "./options/OptionsWrapper";
import PropTypes from "prop-types";
import TypeaheadInput from "./typeahead/TypeaheadInput";
import TypeaheadTextInput from "./typeahead/TypeaheadTextInput";
import { primary } from "@govlaunch/palette";
import { SELECT } from "@govlaunch/css-layers";

export default class CategorySelect extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    value: PropTypes.object,
    disabled: PropTypes.bool,
    validationState: PropTypes.string,
    inputValue: PropTypes.string,
    onInputValueChange: PropTypes.func.isRequired,
    categories: PropTypes.arrayOf(PropTypes.object),
    placeholder: PropTypes.string,
    zIndex: PropTypes.number,
    size: PropTypes.oneOf(["xsmall", "small", "large"]),
  };

  static defaultProps = {
    onFocus: null,
    onBlur: null,
    value: null,
    inputValue: "",
    validationState: null,
    disabled: false,
    categories: [],
    placeholder: null,
    size: "small",
    zIndex: SELECT,
  };

  inputRef = React.createRef();

  handleClear = () => {
    const { onChange, onInputValueChange } = this.props;

    onChange(null);
    onInputValueChange("");

    // we need to wait for the state to change so the component is mounted again
    // and the ref is available
    setTimeout(() => this.inputRef.current.focus(), 1);
  };

  handleChange = category => {
    const { onChange } = this.props;

    onChange(category);

    setTimeout(() => this.containerRef.focus(), 1);
  };

  render() {
    const {
      categories,
      disabled,
      value,
      validationState,
      inputValue,
      onInputValueChange,
      onFocus,
      onBlur,
      placeholder,
      size,
      zIndex,
    } = this.props;

    return (
      <Downshift
        selectedItem={value}
        onChange={this.handleChange}
        inputValue={inputValue}
        onInputValueChange={onInputValueChange}
        itemToString={category => (category ? category.name : null)}
      >
        {({ isOpen, getItemProps, getInputProps, highlightedIndex, inputValue, onInputValueChange }) => {
          const isMenuOpened = isOpen && categories.length > 0;

          return (
            <div>
              <TypeaheadInput
                isOpen={isMenuOpened}
                disabled={disabled}
                validationState={validationState}
                placeholder={placeholder}
                size={size}
                onFocus={onFocus}
                onBlur={onBlur}
              >
                {value ? (
                  <button
                    type="button"
                    css={valueStyle}
                    ref={node => {
                      this.containerRef = node;
                    }}
                    onClick={this.handleClear}
                  >
                    <span>{value.name}</span>
                    {value.ownerless === false && <Claimed />}
                  </button>
                ) : (
                  <TypeaheadTextInput
                    inputRef={this.inputRef}
                    placeholder={placeholder}
                    value={inputValue}
                    onChange={e => onInputValueChange(e.target.value)}
                    {...getInputProps()}
                  />
                )}

                <Clear
                  onClick={this.handleClear}
                  style={{
                    marginTop: 0,
                  }}
                />
              </TypeaheadInput>

              {isMenuOpened && (
                <Menu
                  css={{
                    marginTop: 0,
                    zIndex,
                  }}
                  validationState={validationState}
                >
                  {categories.length > 0 && (
                    <OptionsWrapper>
                      {categories.map((item, index) => (
                        <CategoryOption
                          key={item._id}
                          {...getItemProps({
                            item,
                            active: index === highlightedIndex,
                          })}
                          name={item.name}
                        />
                      ))}
                    </OptionsWrapper>
                  )}
                </Menu>
              )}
            </div>
          );
        }}
      </Downshift>
    );
  }
}

const valueStyle = {
  display: "flex",
  flex: 1,
  alignItems: "center",
  height: "100%",
  paddingLeft: 15,
  letterSpacing: 0.5,
  fontSize: 14,
  fontWeight: 500,
  color: primary,
  background: "none",
  border: 0,
  outline: 0,
};
